import React from "react";
import { ModalShell } from "../../../atoms/ModalShell";
import { CustomButton } from "../../../atoms/CustomButton";

export type CancelMode = "period_end";

interface CancelSubscriptionModalProps {
  show: boolean;
  onClose: () => void;
  planDescription?: string;
  planCode?: string;
  entityName?: string;
  submitting: boolean;
  onConfirm: (mode: CancelMode) => void;
}

export const CancelSubscriptionModal: React.FC<
  CancelSubscriptionModalProps
> = ({
  show,
  onClose,
  planDescription,
  planCode,
  entityName,
  submitting,
  onConfirm,
}) => {
  const footer = (
    <div className="flex flex-wrap justify-end gap-2">
      <CustomButton
        onClick={onClose}
        variant="secondary"
        title="Keep subscription"
        disabled={submitting}
      />
      <CustomButton
        onClick={() => onConfirm("period_end")}
        variant="danger"
        title="Cancel subscription"
        isLoading={submitting}
        disabled={submitting}
      />
    </div>
  );

  return (
    <ModalShell
      show={show}
      onClose={submitting ? () => undefined : onClose}
      size="lg"
      dismissible={!submitting}
      title="Cancel subscription"
      subtitle={entityName}
      footer={footer}
    >
      <div className="space-y-4">
        <p className="text-sm text-gray-700">
          Cancel{" "}
          <span className="font-medium text-gray-900">
            {planDescription || planCode}
          </span>
          .
        </p>

        <div className="rounded-lg border border-gray-200 bg-white p-3">
          <p className="text-sm font-medium text-gray-900">
            At the end of the current period
          </p>
          <p className="mt-0.5 text-xs text-gray-500">
            The subscription keeps running until the period ends, then stops. It
            can be resumed before then.
          </p>
        </div>
      </div>
    </ModalShell>
  );
};

export default CancelSubscriptionModal;
